import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalHttpClient } from '../global.http.client';
import { SelectableCategory } from '../models/categories/category.models';

@Injectable()
export class CategoryService {
    constructor(private http: GlobalHttpClient) {
    }

    getActiveCategories(): Observable<SelectableCategory[]> {
        var response = this.http.get<SelectableCategory[]>('categories/getactive');

        return response;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/category.service.ts